import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const reducer = (state: RootState) => state.private.imageLibrary;

export const imageLibraryListSelector = createSelector(
  reducer,
  state => state.listResponse,
);
